import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { Typography, Grid, Divider, Table, TableBody } from "@mui/material";
import { useIntl, FormattedMessage } from "react-intl";
import ManageRolesTableRow from "./ManageRolesTableRow";

const useStyles = makeStyles(() => ({
  text: {
    fontSize: 12,
    fontWeight: 600,
  },
  divider: {
    marginTop: 10,
    marginBottom: 5,
  },
  table: {
    "& tr:last-child td": {
      borderBottom: "none",
    },
  },
}));

const Files = ({
  disabled,
  handleCheckbox,
  roleSubscriptionLevel,
  siteRoleValues,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const headers = [
    {
      label: intl.formatMessage({ id: "siteRoles.canAddToBasket" }),
      name: "canAddToBasket",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({ id: "siteRoles.allowMetadataTagging" }),
      name: "allowMetadataTagging",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({
        id: "siteRoles.showOnlyOwnFiles",
      }),
      name: "showOnlyOwnFiles",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({
        id: "siteRoles.canUploadFiles",
      }),
      name: "canUploadFiles",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({
        id: "siteRoles.attestFiles",
      }),
      name: "attestFiles",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({
        id: "siteRoles.uploadFilesWithoutAttest",
      }),
      name: "uploadFilesWithoutAttest",
      checkbox: true,
      toolTipInfo: true,
    },
    {
      label: intl.formatMessage({
        id: "siteRoles.canUnlockForOthers",
      }),
      name: "canUnlockForOthers",
      checkbox: true,
      toolTipInfo: true,
    },
  ];

  return (
    <Grid item xs={12} md={6}>
      <Typography className={classes.text}>
        <FormattedMessage id="siteRoles.files" />
      </Typography>
      <Divider className={classes.divider} />
      <Table className={classes.table} size="small">
        <TableBody>
          {headers.map(head => {
            const toolTipInfo = head.toolTipInfo ? head.toolTipInfo : false;
            return (
              <ManageRolesTableRow
                checkbox={head.checkbox}
                disabled={disabled}
                key={head.name}
                label={head.label}
                name={head.name}
                onChange={handleCheckbox}
                roleSubscriptionLevel={roleSubscriptionLevel}
                siteRoleValues={siteRoleValues}
                toolTipInfo={toolTipInfo}
              />
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
};

Files.defaultProps = {
  disabled: false,
  siteRoleValues: {},
};

Files.propTypes = {
  disabled: PropTypes.bool,
  handleCheckbox: PropTypes.func.isRequired,
  handleOpenColorSets: PropTypes.func.isRequired,
  siteRoleValues: PropTypes.shape({}),
};

export default Files;
